<template>
    <div id="load-more" class="pagination__button">
        <button class="button button--lg button--yellow button--rounded">
            <span class="text-small"
                >Showing {{ assetsShown }} of {{ totalAssetsCount }}</span
            >
            <span>LOAD MORE</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        assetsShown: {
            type: Number,
            default: 0,
        },
        totalAssetsCount: {
            type: Number,
            default: 0,
        },
    },
};
</script>

<style lang="scss" scoped>
.pagination__button {
    margin: rem(50) 0 rem(20);
    display: flex;
    justify-content: center;

    button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;

        width: 190px;
        height: 50px;
        border-radius: 6px;

        font-size: 1.1rem;
        font-weight: 700;
        letter-spacing: 0.92px;
        text-transform: uppercase;

        .text-small {
            font-size: 0.7rem;
            font-weight: 400;
        }
    }
}
</style>
